import api from '../api'
import { SEARCH_KEY_QUIZ_ITEMS } from '@/constants/setupQuiz'
import { formatQuizApiError, QUIZ_API_TIMEOUT_MS } from '@/utils/quizApiErrors'

export function collectQuizAnswers(quizItems, quizDraft) {
  return quizItems.map((item) => ({
    question: item.question,
    answer: String(quizDraft[item.id] ?? '').trim(),
  }))
}

export function validateQuizRequired(quizItems, quizDraft) {
  return quizItems.filter((item) => !item.optional && !String(quizDraft[item.id] ?? '').trim())
}

export function quizErrorMessage(error, fallback = 'Не удалось подобрать ключевые слова.') {
  return formatQuizApiError(error, fallback)
}

export function mergeTags(existing, incoming) {
  const seen = new Set((existing || []).map((s) => String(s).trim().toLowerCase()))
  const out = [...(existing || [])]
  for (const raw of incoming || []) {
    const s = String(raw).trim()
    if (!s) continue
    const key = s.toLowerCase()
    if (seen.has(key)) continue
    seen.add(key)
    out.push(s)
  }
  return out
}

export async function submitSearchKeyFromQuiz(answers) {
  const { data } = await api.post('/keys/from-quiz/', { answers }, { timeout: QUIZ_API_TIMEOUT_MS })
  const words = Array.isArray(data.words) ? data.words : []
  const excluded = Array.isArray(data.excluded) ? data.excluded : []
  if (!words.length && !excluded.length) {
    return { ok: false, error: 'Сервис не вернул ключевые слова или исключения.' }
  }
  const suggestedName = String(data.name || '').trim()
  return { ok: true, words, excluded, name: suggestedName }
}

export { SEARCH_KEY_QUIZ_ITEMS }
